import React, { useEffect, useState } from "react";
import "./ClaimTab.css";
import checkIcon from "../../assets/img/claims/check_circle.svg";

const ClaimTab = () => {
  const [isCustomer, setIsCustomer] = useState(true);
  const [responsiveStatus, setResponsiveStatus] = useState(false);

  useEffect(() => {
    const mediaQueries = {
      isSmallMobile: window.matchMedia("(max-width: 400px)"),
      isMobile: window.matchMedia("(max-width: 768px)"),
      isTablet: window.matchMedia("(max-width: 900px)"),
    };

    const updateItemsPerPage = () => {
      if (mediaQueries.isSmallMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isMobile.matches) {
        setResponsiveStatus(true);
      } else if (mediaQueries.isTablet.matches) {
        setResponsiveStatus(true);
      } else {
        setResponsiveStatus(false);
      }
    };

    // Initial run
    updateItemsPerPage();

    // Event listeners
    Object.values(mediaQueries).forEach((mq) =>
      mq.addEventListener("change", updateItemsPerPage)
    );

    // Cleanup
    return () => {
      Object.values(mediaQueries).forEach((mq) =>
        mq.removeEventListener("change", updateItemsPerPage)
      );
    };
  }, []);

  return (
    <div
      className="container mt-5"
      style={{ margin: responsiveStatus ? "0px 0px 0px -7px" : "" }}
    >
      <div
        className="mx-auto border rounded shadow p-4 bg-white"
        style={{ maxWidth: "650px" }}
      >
        {/* Tabs */}
        <div
          className="d-flex border-bottom mb-3"
          style={{
            overflowX: "auto", // Enables horizontal scroll
            WebkitOverflowScrolling: "touch", // Smooth scroll on iOS
            scrollbarWidth: "none", // Hide scrollbar (Firefox)
          }}
        >
          <div
            style={{
              display: "flex",
              minWidth: "max-content", // Ensures children don't wrap
            }}
          >
            <button
              className={`btn flex-fill  ${
                isCustomer ? "text-dark" : "text-muted"
              }`}
              style={{
                borderRadius: 0,
                borderBottom: isCustomer ? "2px solid #0e72d6" : "none",
                whiteSpace: responsiveStatus ? "nowrap" : "normal",
              }}
              onClick={() => setIsCustomer(true)}
            >
              I’m UAIC Customer
            </button>
            <button
              className={`btn flex-fill text-truncate ${
                !isCustomer ? "fw-bold text-dark" : "text-muted"
              }`}
              style={{
                borderRadius: 0,
                borderBottom: !isCustomer ? "2px solid #0e72d6" : "none",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: responsiveStatus ? "nowrap" : "normal",
              }}
              onClick={() => setIsCustomer(false)}
            >
              I’m not a UAIC Customer
            </button>
          </div>
        </div>

        {/* Content */}
        {isCustomer && (
          <>
            <p className="text-secondary text-left">
              As a valued customer, filing a claim is quick and convenient
              through our app or website. Log in to your account, provide the
              required details, and track your claim status in real time.
            </p>

            <div className="row" style={{ marginLeft: "0px" }}>
              <div
                className={`col-12 col-sm-5 mb-1`}
                style={{ padding: 0, margin: 0 }}
              >
                <ul
                  className="d-block flex-wrap gap-1"
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {[
                    "File a claim",
                    "View Claim(s)",
                    "View Coverages",
                    "Check Claim Status",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "4px",
                        display: "flex",
                        alignItems: "left",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="claimTextStyle">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div
                className={`col-12 col-sm-7 mb-1 `}
                style={{ padding: 0, margin: 0 }}
              >
                <ul
                  className="d-block flex-wrap gap-1"
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {[
                    "Send Documents",
                    "Contact Your Adjuster",
                    "Schedule Vehicle Damage Estimate",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="claimTextStyle">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-4 text-left">
              <a
                href="https://mypolicy.uaig.net/insurednew/insured/claimuser/index"
                target="_blank"
                rel="noreferrer"
                className="btn btn-style px-4"
              >
                Login
              </a>
            </div>
          </>
        )}
        {!isCustomer && (
          <>
            <p className="text-secondary text-left">
              Not a customer yet? No problem! You can easlily file a claim
              through our platform. Provide your details and relevant
              information, and our team will assist you promptly. Experience
              hassle-free support, anytime.
            </p>

            <div className="row" style={{ marginLeft: "0px" }}>
              <div
                className={`col-12 col-sm-5 mb-1`}
                style={{ padding: 0, margin: 0 }}
              >
                <ul
                  className="d-block flex-wrap gap-1"
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {["File a claim", "Check Claim Status", "Send Documents"].map(
                    (item, i) => (
                      <li
                        key={i}
                        style={{
                          marginBottom: "4px",
                          display: "flex",
                          alignItems: "left",
                        }}
                      >
                        <img
                          src={checkIcon}
                          alt="check"
                          style={{ width: "20px", marginRight: "10px" }}
                        />
                        <span className="claimTextStyle">{item}</span>
                      </li>
                    )
                  )}
                </ul>
              </div>
              <div
                className={`col-12 col-sm-7 mb-1 `}
                style={{ padding: 0, margin: 0 }}
              >
                <ul
                  className="d-block flex-wrap gap-1"
                  style={{ listStyle: "none", padding: 0, margin: 0 }}
                >
                  {[
                    "Contact Your Adjuster",
                    "Schedule Vehicle Damage Estimate",
                  ].map((item, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px", marginRight: "10px" }}
                      />
                      <span className="claimTextStyle">{item}</span>
                    </li>
                  ))}
                </ul>
                {/* {features1.map((feature, idx) => (
                  <>
                    <span
                      className="text-success"
                      style={{ marginRight: "5px" }}
                    >
                      <img
                        src={checkIcon}
                        alt="check"
                        style={{ width: "20px" }}
                      />
                    </span>
                    <span
                      style={{
                        fontSize: "13px",
                        fontWeight: 400,
                        lineHeight: "100%",
                        textAlign: "left",
                        color: "#515050",
                        marginTop: "8px",
                      }}
                    >
                      {feature}
                    </span>
                  </>
                ))} */}
              </div>
            </div>

            <div className="mt-4 text-left">
              <a
                href="https://account-management-claims-uaic-gwcpprod-prod.delta4-andromeda.guidewire.net/account-management-claims/tpp-claims"
                target="_blank"
                rel="noreferrer"
                className="btn btn-style px-4"
              >
                Login
              </a>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ClaimTab;
